<script lang="ts" setup>
import DirectionColumnIfMobileContainer from '../../DirectionColumnIfMobileContainer.vue';
import ResearchDataCard from '../../ResearchData/ResearchDataCard.vue';
import Img1 from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/ResearchDataCard/7.jpeg/7.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  num: number;
}>();
</script>

<template>
  <ResearchDataCard :num="num" :class="$style.container">
    <template #title>
      <strong>金利上昇を懸念？</strong>マイホーム購入希望者の<strong
        >35.9％が固定金利を選択。変動金利28.2%より高い傾向に</strong
      >
    </template>
    <DirectionColumnIfMobileContainer>
      <PinchImageModal :src="Img1" alt="グラフ" />
      <div>
        <p>
          マイホーム所有の検討を始めていると回答した方へ、
          <strong
            >「2024年3月にマイナス金利政策解除が発表されましたが、住宅を購入する場合、住宅ローンは何を選びますか」</strong
          >
          と質問したところ、
          <strong>固定金利35.9％、変動金利28.2%</strong>
          となりました。
        </p>
        <p>
          これまでの超低金利時代の終焉を見据えた結果か、固定金利を選択する方が変動金利より多いことが伺えます。
        </p>
      </div>
    </DirectionColumnIfMobileContainer>
  </ResearchDataCard>
</template>

<style lang="scss" module>
.container {
  :nth-child(n + 2) {
    margin-top: 8px;
  }
}
</style>
